export default function focusInputByName(name) {
  if (name)
    return (
      document.getElementsByName(name)[0] &&
      document.getElementsByName(name)[0].focus()
    );

  return true;
}
